import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import ApiService from "@/core/services/ApiService";

const app = createApp(App).use(store).use(router);
ApiService.init(app);
app.mount('#app')